import { approveSellYourBusinessRequest, deleteSellYourBusiness, getAllDealership, getAllSaleYourBusiness, updateSellYourBusiness } from '../../redux/actions/AllActions';
import React, { useEffect, useState } from 'react';
import { Button, Image, Layout, message, Modal, Select, Space, Switch, Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getAllFranchaise } from '../../redux/actions/AllActions'
import { Content } from 'antd/es/layout/layout';
import EditSellYourBusiness from '../EditSellYourBusiness/EditSellYourBusiness';
import { Option } from 'antd/es/mentions';
import Loading from '../../components/Loading/Loading';
import Filter from '../../components/Filter/Filter';
import AddSellYourBusiness from '../Add/AddSellYourBusiness/AddSellYourBusiness';
import SellYourBusinessDetails from '../../components/Deatails/SellYourBusinessDetails/SellYourBusinessDetails';


const Sellyoubusiness = () => {
    const navigate = useNavigate();
    
    const dispatch = useDispatch();
    
    const { data, loading } = useSelector((state) => state.data);

    const [filteredItems, setFilteredItems] = useState([]);
    const [isEditingModelVisible, setIsEditingModelVisible] = useState(false);
    const [isCreateModelVisible, setIsCreateModelVisible] = useState(false);
    const [handleDetailsVisible, setHandleDetailsVisible] = useState(false);
    const [editingRecord, setEditingRecord] = useState(null);

    const [admin, setAdmin] = useState("");
 

    useEffect(() => {
        const adminData = localStorage.getItem("admindata");
        try {
            const parsedData = JSON.parse(adminData);
            if (parsedData && typeof parsedData === "object") {
                setAdmin(parsedData);
            } else {
                console.error("Invalid admin data structure");
                localStorage.removeItem("admindata");
            }
        } catch (error) {
            console.error("Error parsing admin data:", error);
            localStorage.removeItem("admindata");
        }
    }, []);


    useEffect(() => {
        setFilteredItems(data);
    }, [data]);
    
    
    const fetch = () => {
        dispatch(getAllSaleYourBusiness());

    }



    useEffect(() => {
        fetch()
    }, [dispatch]);

    const handleEdit = (record) => {
        setEditingRecord(record);
        setIsEditingModelVisible(true);
    };

    const handleDelete = (record) => {
        Modal.confirm({
            title: 'Are you sure you want to delete this user?',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk: async () => {
                try {
                    const resp = await (deleteSellYourBusiness(record._id));
                    console.log('the response is', resp)
                    if (resp?.data?.success) {
                        fetch();
                        message.success('Sellyourbusiness deleted successfully');
                    } else {
                        message.error('Failed to delete user');
                    }
                } catch (error) {
                    message.error('An error occurred while deleting the user');
                }
            },
        });



    };

    const handleDetails = (record) => {
        setEditingRecord(record);
        setHandleDetailsVisible(true);
    };

    const handleEditCancel = () => {
        setIsEditingModelVisible(false);
    };

  const handleChangeStatus = async (e, record) => {
      try {
            
          console.log('the record is',record)
          const response = await approveSellYourBusinessRequest(e, record?._id)
            dispatch(getAllDealership());
            message.success("Status Changed Successfully")
        } catch (e) {
            // alert("Changing Status of Franchise failed")
            message.error("Changing Status of Franchise failed")

        }
    }










    const columns = [
        {
            title: 'Business Name',
            dataIndex: 'businessName',
            key: 'businessName',
            width: 300,
        },
        {
            title: "Name ",
            dataIndex: 'user',
            key: 'status',
            width: 300,
            render: (_, record) => {
                return (<div>
                    {record?.user?.name}
                </div>)

            }
        },
        {
            title: "Email ",
            dataIndex: 'user',
            key: 'status',
            width: 300,
            render: (_, record) => {
                return (<div>
                    {record?.user?.email}
                </div>)

            }
        },
        {
            title: 'Gst Number',
            dataIndex: 'gstNumber',
            key: 'gstNumber',
            width: 300,
        },




        {
            title: "Paid",
            dataIndex: 'isApproved',
            key: 'isApproved',
            width: 300,
            render: (_, record) => (<Space>
                {record?.payment_status === "paid" ?
                    <div
                        style={{
                            background: "green",

                            color: "white",
                            padding: "10px 20px",
                            borderRadius: "2px",
                            fontWeight: 'bold',
                            letterSpacing: "1px",
                            fontSize: "13px",
                            width: "120px",
                            textAlign: "center"
                        }}
                    >
                        Paid
                    </div>
                    : <div

                        style={{
                            background: "red",
                            color: "white",
                            padding: "10px 20px",
                            borderRadius: "2px",
                            fontWeight: 'bold',
                            letterSpacing: "1px",
                            fontSize: "13px",
                            width: "120px",
                            textAlign: "center"
                        }}
                    >
                        Not Paid
                    </div>
                }

            </Space>)
        },
        {
            title: "Approve",
            dataIndex: 'status',
            key: 'status',
            width: 300,
            render: (_, record) => (<Space>
                <div>
                    <Select
                        disabled={record?.payment_status !== 'paid' || record?.status === 'accepted'}
                        style={{
                            width: "100px"
                        }}
                        onChange={(e) => { handleChangeStatus(e, record) }}
                        value={record.status}>
                        <Option value="pending">Pending</Option>
                        <Option value="rejected">Reject</Option>
                        <Option value="accepted">Accept</Option>
                    </Select>
                </div>

            </Space>)
        },









        {
            title: 'Entity Type',
            dataIndex: 'entityType',
            key: 'entityType',
            width: 300,
        },
        {
            title: 'Business Category',
            dataIndex: 'businessCategory',
            key: 'businessCategory',
            width: 300,
        },
        {
            title: 'Business Address',
            dataIndex: 'businessAddress',
            key: 'businessAddress',
            width: 300,
        },
        {
            title: 'Business Overview',
            dataIndex: 'businessOverview',
            key: '',
            width: 300,
        },
        {
            title: 'Business Photo Url',
            dataIndex: 'businessPhotoUrl',
            key: 'businessPhotoUrl',
            width: 300,
            render: (_, record) => (
                <Space>

                    {
                        // admin?.role === 'superAdmin' &&
                        <div
                            style={{
                                display: 'flex',
                                width: "100px"
                            }}
                        >
                            <Image

                                src={record?.businessPhotoUrl}
                            />

                        </div>
                    }     </Space>
            ),
        },

        {
            title: 'Logo Photo Url',
            dataIndex: 'logoPhotoUrl',
            key: 'logoPhotoUrl',
            width: 300,
            render: (_, record) => (
                <Space>

                    {
                        // admin?.role === 'superAdmin' &&
                        <div
                            style={{
                                display: 'flex',
                                width: "100px"
                            }}
                        >
                            <Image

                                src={record?.logoPhotoUrl}
                            />

                        </div>
                    }     </Space>
            ),
        },


        {
            title: 'Royalty Percentage',
            dataIndex: 'royaltyPercentage',
            key: 'royaltyPercentage',
            width: 300,
        },

        {
            title: 'RequiredArea Sq Ft',
            dataIndex: 'requiredAreaSqFt',
            key: 'requiredAreaSqFt',
            width: 300,
        },
    
  
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <Space>

                    {
                        // admin?.role === 'superAdmin' &&
                        <div
                            style={{
                                display: 'flex',
                                width: "200px"
                            }}
                        >
                            <Button type="link" onClick={() => handleEdit(record)}>
                                Edit
                            </Button>
                            <Button type="link" onClick={() => handleDetails(record)}>
                                Details
                            </Button>
                            <Button type="link" danger onClick={() => handleDelete(record)}>
                                Delete
                            </Button>

                        </div>
                    }     </Space>
            ),
        },
    ];

        const handleEditApi = async () => {
            
            const update = await updateSellYourBusiness(editingRecord?._id);
            console.log(update,'the updat is ')
    
            
        }
    

  return (
      <div>
          <Button
          onClick  ={() => setIsCreateModelVisible(true)}
          >+ Add Sell your business</Button>
          
          {
              loading ?
                  <Loading/> :
                  <>

                      <Layout>
                          <Filter
                              allData={data}
                              setFilteredItems={setFilteredItems}
                              searchKeys={['gst', 'territoryAvailability', 'businessName']}
                          />
              <Content>
                  <div style={{ overflowX: 'auto', width: '100%' }}>
                      <Table
                          columns={columns}
                          pagination={{ position: ['bottomCenter'], pageSize: 10 }}
                          dataSource={filteredItems}
                          rowKey={(record) => record._id}
                          style={{ minHeight: '80vh', maxHeight: '80vh' }}
                      />
                  </div>
              </Content>

              {/* Edit User Modal */}
              <Modal
                  title="Edit Sell Your business"
                  open={isEditingModelVisible}
                  onCancel={handleEditCancel}
                  footer={null}
              >
                  <EditSellYourBusiness
                                  editingRecord={editingRecord}
                                  handleEditCancel={handleEditCancel}
                              />
                              
              
              </Modal>

              {/* Details Modal */}
              <Modal
                  title="Sell your business Details"
                  open={handleDetailsVisible}
                  onCancel={() => setHandleDetailsVisible(false)}
                  footer={null}
                          >
                              <SellYourBusinessDetails
                              data ={editingRecord}
                              />
            
              </Modal>
                      </Layout>
                  </>
          }
             <Modal
                        title="Add Sell Your Businesss"
              visible={isCreateModelVisible}
              onCancel={() => setIsCreateModelVisible(false)}
                        footer={null}
                    >
              <AddSellYourBusiness setIsCreateModelVisible={setIsCreateModelVisible} />
                    </Modal>

          
      </div>
  )
}

export default Sellyoubusiness